<template>
  <modal name="purchaser-logist-modal" height="auto" width="480px" style="margin-top: 40px;" :scrollable="true" :shiftY="0.2">
    <div class="close">
      <img class="hover_btn" src="../../assets/icons/close.svg" @click="close()"  alt="">
    </div>
    <div class="modal-form">
      <div class="input-block">
        <h4>Фамилия</h4>
        <div class="input-block">
          <input v-model="surname" class="receiver_name_input" style="margin-bottom: 4px;" placeholder="Фамилия" v-validate="'required'" name="surname" data-vv-as="фамилия" >
          <span class="text-danger text-sm">{{ errors.first('surname') }}</span>
        </div>
        <h4>Имя</h4>
        <div class="input-block">
          <input v-model="name" class="receiver_name_input" style="margin-bottom: 4px;" placeholder="Имя" v-validate="'required'" name="name" data-vv-as="имя" >
          <span class="text-danger text-sm">{{ errors.first('name') }}</span>
        </div>
        <h4>Телефон</h4>
        <div class="input-block">
          <input v-model="phone" id="phone-field" ref="pfil" class="receiver_phone" v-validate="'required'" name="phone" data-vv-as="телефон" placeholder="Телефон" >
          <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
        </div>
      </div>
      <div class="btn">
        <button @click="addLogist()">Сохранить</button>
      </div>
    </div>
  </modal>
</template>

<script>

import Inputmask from "inputmask";

export default {
  name: "purchaser-logist-modal",
  data: ()=> ({
    name: '',
    phone: '',
    surname: '',
    id: ''
  }),
  methods: {
    open(logist = null){
      if (logist) {
        this.name = logist.name;
        this.phone = logist.phone;
        this.surname = logist.surname;
        this.id = logist.id;
      }
      let im = new Inputmask("+7 (999) 999 99 99");
      setTimeout(() => im.mask(this.$refs.pfil), 1);
      this.$modal.show('purchaser-logist-modal');
    },
    close() {
      this.$modal.hide('purchaser-logist-modal');
    },
    addLogist() {
      this.$validator.validateAll()
          .then(success=>{
            if(success){
              this.$http.post('/add-purchaser-logist', {
                token: localStorage.getItem('token'),
                name: this.name,
                phone: this.phone,
                surname: this.surname,
                id: this.id
              }).then(({data}) => {
                if (data.success) {
                  this.$toast.success(this.id ? 'Данные успешно изменены!' : 'Данные успешно добавлены!');
                  this.$modal.hide('purchaser-logist-modal');
                  this.$emit('saved', '');
                }
              }).catch((error) => {
                console.log(error)
              })
            }
          })
    }
  }
}
</script>

<style scoped lang="scss">

.progress-bar-container {
  width: 140px;
  margin: 0px auto;
}

.order-info {
  font-size: 14px;
  margin-right: 10px;
}

.btn{
  width: 100%;
  padding: 0;
  button{
    width: 100%;
    height: 50px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    background: #2CB181;
    border-radius: 4px;
    border: none;
  }
}
.modal-form {
  padding: 30px;
}
.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;
  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
input{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
</style>
